module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bottom",
      rawName: "v-bottom",
      value: (0),
      expression: "0"
    }],
    staticClass: "twui-page",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "twui-doccenter xnew"
  }, [_c('tw-header', {
    on: {
      "signin": function($event) {
        _vm.dialogLogin = true
      },
      "signup": function($event) {
        _vm.dialogLoginIn = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-body"
  }, [_c('div', {
    staticClass: "twui-body-inner"
  }, [_c(_vm.$store.state.pageName, {
    tag: "component"
  })], 1)]), _vm._v(" "), _c('tw-footer'), _vm._v(" "), _c('div', {
    staticClass: "twui-rightside"
  }, [_c('tw-totop')], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "twui-login",
    attrs: {
      "title": "天闻ECO云开放平台登录",
      "visible": _vm.dialogLogin,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogLogin = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('i', {
    staticClass: "ico ico-login-user"
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入登录帐号或邮箱"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('i', {
    staticClass: "ico ico-login-pwd"
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "auto-complete": "off",
      "type": "password",
      "placeholder": "请输入密码"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('i', {
    staticClass: "ico ico-login-org"
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择机构"
    },
    model: {
      value: (_vm.org),
      callback: function($$v) {
        _vm.org = $$v
      },
      expression: "org"
    }
  }, _vm._l((_vm.orgList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticClass: "twui-login-code",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入验证码"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/dev/images/code.png"
    }
  }), _vm._v(" "), _c('a', [_vm._v("  换一换")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "twui-login-remember"
  }, [_c('el-checkbox', [_vm._v("下次自动登录")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/find_password"
    }
  }, [_vm._v("忘记密码")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "twui-btn xmain xxlarge xfull",
    on: {
      "click": function($event) {
        _vm.dialogLogin = false
      }
    }
  }, [_vm._v("登录")])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "twui-loginin",
    attrs: {
      "title": "注册—请选择你的身份",
      "visible": _vm.dialogLoginIn,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogLoginIn = $event
      }
    }
  }, [_c('div', {
    staticClass: "twui-grid xpc-x5"
  }, [_c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/teacher.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是老师")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/student.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是学生")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/school.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是学校管理员")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/region.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是区域管理员")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/dev.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是应用开发者")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7f4d4432","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 598
// module chunks = 1